export default __webpack_public_path__ + "static/lava-df7eb1d7e1bf807d15f58d34fdc5d96d.png";